// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__u4oPN","upload":"Small_upload__2nGAL","imageWrap":"Small_imageWrap__3JYdz","removeBtn":"Small_removeBtn__1Y7bi"};